import { cloneDeep } from 'lodash';
import moment from 'moment-timezone';

import {
  Operator,
  numberOp,
  EStatusStr,
  EStatus,
  EStringOp,
  EBlockedEventType,
} from '@src/emp-3.0/types';
import {
  isEventAttributeType,
  isGlobalAttributeType,
} from '@src/emp-3.0/components/custom-dimension/utils';

export const DATE_FORMAT_STRING = 'YYYY-MM-DD HH:mm:ss';

export const formatTimestamp = (
  timestamp?: number | null,
  format: string = DATE_FORMAT_STRING,
  fallback = '--',
): string => {
  if (typeof timestamp === 'number') {
    if (timestamp === 0) {
      return fallback;
    }
    return moment(timestamp * 1000).format(format);
  }
  return fallback;
};

/**
 * Default: Replace underscores with spaces and capitalize the first letter of each word
 * @param key key in various cases: Camel Case (firstName), Snake Case (first_name), Kebab Case (first-name), and Pascal Case (FirstName)
 * @param separator string | RegExp Separator used to split the key into words
 */
export const keyToLabel = (key: string, separator: string | RegExp = '_') => {
  return key
    .split(separator)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const removeEmptyFilters = (filters) => {
  const filtersCopy = cloneDeep(filters);
  return filtersCopy.filter((item) => item.filter((x) => x.value?.length)?.length);
};

export function formatOperator(operator: Operator): string {
  switch (operator) {
    case EStringOp.EQ:
      return '=';
    case EStringOp.NOT_EQ:
      return 'not equals';
    default:
      return operator;
  }
}

export const formatStatus = (status?: number): string | null => {
  if (status === EStatus.DEPLOYED) return EStatusStr.Deployed;
  if (status === EStatus.UNDEPLOYED) return EStatusStr.Undeployed;
  return null;
};

export const formatAttributeType = (status?: number): string | null => {
  if (isEventAttributeType(status)) return 'Event';
  if (isGlobalAttributeType(status)) return 'Global';
  return null;
};

export const formatBlockEventType = (blockRules: (string | number)[]) => {
  if (!Array.isArray(blockRules)) return null;
  return blockRules?.length === 0 ? EBlockedEventType.BLOCK_ALL : EBlockedEventType.BLOCK_BY_RULES;
};
